module.exports = __webpack_public_path__ + "static/usecase_phone2@2x-a5c742b4eead878b2fcc819f4559e426.png";